import { useState } from "react";
import { CalendarDays, CalendarRange } from "lucide-react";

const monthEnd = (ym) => { const [y, m] = ym.split("-").map(Number); return `${ym}-${String(new Date(y, m, 0).getDate()).padStart(2, "0")}`; };
const isWholeMonth = (from, to) => !!from && !!to && from.slice(0, 7) === to.slice(0, 7) && from.endsWith("-01") && to === monthEnd(from.slice(0, 7));
const inp = "w-full px-2.5 py-1.5 text-xs border border-slate-300 rounded-md disabled:bg-slate-50 disabled:text-slate-400";

// Hakediş dönemi: "Ay" (tek seçimle ayın 1'i – son günü) ya da "Tarih Aralığı" (iki tarih); dışarıya her zaman date_from / date_to verir
export default function PeriodPicker({ from, to, onChange, disabled = false, testid = "filter-period" }) {
  const [mode, setMode] = useState(() => (isWholeMonth(from, to) ? "month" : "range"));
  const month = from ? from.slice(0, 7) : "";
  const Tab = ({ id, icon: Icon, label }) => (
    <button type="button" onClick={() => setMode(id)} disabled={disabled} data-testid={`${testid}-mode-${id}`} aria-pressed={mode === id}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-semibold border transition-colors disabled:opacity-50 ${mode === id ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-300 hover:border-slate-500"}`}>
      <Icon className="w-3 h-3" /> {label}
    </button>
  );
  return (
    <div className="space-y-1" data-testid={testid}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <label className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">Dönem</label>
        <div className="flex items-center gap-1"><Tab id="month" icon={CalendarDays} label="Ay" /><Tab id="range" icon={CalendarRange} label="Tarih Aralığı" /></div>
      </div>
      {mode === "month"
        ? <input type="month" data-testid={`${testid}-month`} disabled={disabled} value={month} onChange={(e) => e.target.value && onChange(`${e.target.value}-01`, monthEnd(e.target.value))} className={inp} title="Ay seçin — dönem ayın 1'i ile son günü olur" />
        : <div className="grid grid-cols-2 gap-2">
            <input type="date" data-testid={`${testid}-from`} disabled={disabled} value={from} onChange={(e) => onChange(e.target.value, to)} className={inp} title="Başlama tarihi" />
            <input type="date" data-testid={`${testid}-to`} disabled={disabled} value={to} min={from || undefined} onChange={(e) => onChange(from, e.target.value)} className={inp} title="Bitiş tarihi" />
          </div>}
    </div>
  );
}
